const getCurrentLocation = () => {
	const currentCookie = document.cookie
		.split('; ')
		.find((row) => row.startsWith('fsa_location='));

	if (!currentCookie) {
		return null;
	}

	const cookieValue = currentCookie.split('=')[1];

	if (!cookieValue) {
		return '';
	}

	return JSON.parse(decodeURIComponent(cookieValue));
};

export default getCurrentLocation;
